import React from 'react';
export const Terms = () => {
  return <div className="py-20 lg:py-24 bg-white min-h-[calc(100vh-300px)]" data-id="element-1120">
      <div className="max-w-content mx-auto px-5 sm:px-8 lg:px-12" data-id="element-1121">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-1122">
          <h1 className="text-4xl md:text-5xl font-heading font-bold text-ink mb-6 leading-tight" data-id="element-1123">
            Terms & Conditions
          </h1>
          <p className="text-lg text-gray-600" data-id="element-1124">
            The terms governing your use of our website and services.
          </p>
        </div>

        <div className="max-w-3xl mx-auto prose prose-lg prose-red text-gray-600" data-id="element-1125">
          <p data-id="element-1126">Last Updated: January 1, 2026</p>

          <h3 data-id="element-1127">Acceptance of Terms</h3>
          <p data-id="element-1128">
            By accessing or using the Custom Uniform Supplier website and
            services, you agree to be bound by these Terms and Conditions. If
            you do not agree to these terms, please do not use our services.
          </p>

          <h3 data-id="element-1129">Wholesale Accounts</h3>
          <p data-id="element-1130">
            Wholesale access is granted at our sole discretion. We reserve the
            right to revoke wholesale privileges if an account violates our
            terms, engages in fraudulent activity, or fails to meet minimum
            ordering requirements.
          </p>

          <h3 data-id="element-1131">Order Processing and Payment</h3>
          <p data-id="element-1132">
            All orders require full payment or an approved purchase order before
            production begins. Once an order is placed and the final mockup is
            approved, it cannot be canceled or modified.
          </p>

          <h3 data-id="element-1133">Production Timelines</h3>
          <p data-id="element-1134">
            Estimated production times are provided as guidelines and are not
            guaranteed delivery dates. We are not liable for delays caused by
            factors beyond our reasonable control, including but not limited to
            shipping carrier delays, customs holds, or acts of God.
          </p>

          <h3 data-id="element-1135">Limitation of Liability</h3>
          <p data-id="element-1136">
            In no event shall Custom Uniform Supplier be liable for any
            indirect, incidental, special, or consequential damages arising out
            of or in connection with your use of our products or services.
          </p>
        </div>
      </div>
    </div>;
};